
export const NOTIFICATION_DEVICE_ID_KEY = 'nc_notification_device_id';
export const NOTIFICATION_FCM_TOKEN_KEY = 'nc_notification_fcm_token';
